<template>
    <div>
        <annual-leave-employee-list></annual-leave-employee-list>
    </div>
    </template>
    <script>
    export default {}
    </script>
    